import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tngh-form-field',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent {
  @Input() label = '';
  @Input() labelSrOnly = false;
  @Input() helpText?: string;
  @Input() labelId = '';
  @Input() helpTextId = '';
  @Input() required: boolean = false;
}
